import React from 'react';
import {connect} from 'react-redux';
import {array, func, object, bool} from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import MobileNavHeader from './MobileNavHeader/MobileNavHeader';
import MobileNavSearchBar from './MobileNavSearchBar/MobileNavSearchBar';
import MobileNavMenu from './MobileNavMenu/MobileNavMenu';
import styles from './mobileNav.scss';
import MobileNavAnimationSlide from './MobileNavAnimations/MobileNavAnimationSlide';
import MobileNavDrawer from './MobileNavDrawer/MobileNavDrawer';
import MessageBanner from '../MessageBanner/MessageBanner';
import classnames from 'classnames';
import {actionCreators} from '../../actions';

export class MobileNav extends React.Component {
    constructor() {
        super();

        this.state = {
            applyOpenStyle: false,
            isSearchOpen: false,
            searchValue: ''
        };

        this.onHeaderActionClick = this.onHeaderActionClick.bind(this);
        this.onAnimationEnd = this.onAnimationEnd.bind(this);
        this.handleSearchInput = this.handleSearchInput.bind(this);
        this.handleSearchOpen = this.handleSearchOpen.bind(this);
        this.handleSearchClose = this.handleSearchClose.bind(this);
    }

    onHeaderActionClick() {
        this.props.dispatch(actionCreators.toggleMobileMenu(!this.props.isMobileMenuOpen));
        this.setState({
            applyOpenStyle: true
        });
    }

    handleSearchInput(searchValue) {
        this.setState({searchValue});
    }

    handleSearchOpen() {
        this.setState({
            isSearchOpen: true,
            applyOpenStyle: true
        });
    }

    handleSearchClose() {
        this.setState({
            isSearchOpen: false,
            searchValue: ''
        });
    }

    onAnimationEnd() {
        if (!this.props.isMobileMenuOpen && !this.state.isSearchOpen) {
            this.setState({
                applyOpenStyle: false
            });
        }
    }

    render() {
        const {applyOpenStyle, isSearchOpen, searchValue} = this.state;
        const {onAuthClick, handleNavigateAction, viewer, user, isMobileMenuOpen} = this.props;
        const {hasUserId, isClient, showMarketingMessages, userIds} = this.props;
        const isDrawerDisabled = isMobileMenuOpen || isSearchOpen;
        const drawerClass = classnames(styles.container, {
            [styles.isOpen]: applyOpenStyle
        });
        const hasUser = !!user;
        const hasRootPendingRefetch = !hasUser && hasUserId;

        return (
            <div>
                <div className={styles.spacer}>
                    <MobileNavDrawer className={drawerClass} disabled={isDrawerDisabled}>
                        <MobileNavHeader
                            user={user}
                            useCloseIcon={isMobileMenuOpen}
                            onActionClick={this.onHeaderActionClick}
                            handleNavigateAction={handleNavigateAction}
                        />
                        <MobileNavSearchBar
                            viewer={viewer}
                            isOpen={isSearchOpen}
                            value={searchValue}
                            handleNavigateAction={handleNavigateAction}
                            onInput={this.handleSearchInput}
                            onClose={this.handleSearchClose}
                            onOpen={this.handleSearchOpen}
                            onAnimationEnd={this.onAnimationEnd}
                        />
                        <MobileNavAnimationSlide
                            in={isMobileMenuOpen}
                            onAnimationEnd={this.onAnimationEnd}
                            scrollLock
                        >
                        <MobileNavMenu
                            onAuthClick={onAuthClick}
                            viewer={viewer}
                            user={user}
                            onCloseClick={this.closeMenu}
                            handleNavigateAction={handleNavigateAction}
                        />
                        </MobileNavAnimationSlide>
                    </MobileNavDrawer>
                </div>
                {showMarketingMessages ?
                    <MessageBanner
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        isClient={isClient}
                        isMobile
                        message={null}
                        showMarketingMessages={showMarketingMessages}
                        user={user}
                        userIds={userIds}
                        viewer={viewer}
                    />
                    : null
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isMobileMenuOpen: state.header.isMobileMenuOpen
    };
}

export default createFragmentContainer(
    connect(mapStateToProps)(MobileNav),
    {
        viewer: graphql`
            fragment MobileNav_viewer on Viewer {
                ...MobileNavMenu_viewer
                ...MobileNavSearchBar_viewer
                ... on Viewer @include(if: $showMarketingMessages) {
                    ...MessageBanner_viewer
                }
            }
        `,
        user: graphql`
            fragment MobileNav_user on User {
                ...MobileNavMenu_user
                ...MobileNavHeader_user
                ... on User @include(if: $showMarketingMessages) {
                    ...MessageBanner_user
                }
            }
        `
    }
);

MobileNav.propTypes = {
    viewer: object.isRequired,
    user: object,
    onAuthClick: func.isRequired,
    handleNavigateAction: func.isRequired,
    hasUserId: bool,
    isClient: bool,
    isMobileMenuOpen: bool,
    dispatch: func.isRequired,
    showMarketingMessages: bool,
    userIds: array
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNav.jsx